export default "__VITE_ASSET__unF6RyO1__"